import React from "react";
import { CONSTANTS, NUMBER_FORMATS } from "../../../constants/app-constant";
import { Table } from "react-bootstrap";
import { getCommaSeparatedNumbers } from "../../../utility/common-methods";
const { DATA_NOT_FOUND } = CONSTANTS;

const ReachChart = ({ chartTitle, data }) => {
  return (
    <div className="customTableWrap">
      <div className="widgetHeading">Reach</div>
      <div className="table-responsive">
        <Table className="table table-sm table-bordered customTable">
          <thead>
            <tr>
              <th>Topic</th>
              <th>Reach</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) &&
              data.map((el) => {
                const { topic_id, topic_name, topic_category, reach_count } =
                  el || {};
                if (reach_count > 0) {
                  return (
                    <React.Fragment key={topic_id}>
                      <tr>
                        <td>{topic_name}</td>
                        <td>
                          {getCommaSeparatedNumbers(
                            reach_count,
                            NUMBER_FORMATS.EN_IN
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                }
              })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ReachChart;
